module.exports = __webpack_public_path__ + "static/media/culture-icon.aa09d7da.svg";